import { useFormikContext } from 'formik';

import { useAlert } from 'hooks';
import { Button } from 'components';
import { ButtonColors } from 'types';

import { FullAmountButtonProps } from './types';

export const FullAmountButton = <T extends object>({
  onClick,
  remainder,
  isBalanceZero,
  fieldName = 'amount',
}: FullAmountButtonProps) => {
  const { showErrorAlert } = useAlert();
  const { setFieldValue } = useFormikContext<T>();

  const onFullPriceClick = () => {
    setFieldValue(fieldName, remainder);
    onClick?.();
  };

  return (
    <div>
      <Button
        transparent
        padding="0"
        text="Full price"
        colorType={ButtonColors.LightBlue}
        onClick={() =>
          !isBalanceZero
            ? onFullPriceClick()
            : showErrorAlert(
                'Balance due is zero or negative, enter the desired amount'
              )
        }
      />
    </div>
  );
};
